import {Button, Col, Row} from "react-bootstrap";
import PropTypes from "prop-types";
import {ClipLoader} from "react-spinners";

export function ButtonLoading(props) {
    const {title, className, isLoading, onClick} = props

    return <Button className={className ? className :""} disabled={isLoading} onClick={onClick}>
        <Row className={"g-0"}>
            {isLoading ? <Col>
                    <ClipLoader size={20}/>
                </Col>
                :
                <Col>
                    {title ? title : "SET TITLE PLZ!!"}
                </Col>}
        </Row>
    </Button>
}

ButtonLoading.propTypes = {className:PropTypes.string,title: PropTypes.string, isLoading: PropTypes.bool, onClick: PropTypes.func}